<template>
	<el-dialog
		title="收货地址"
		:visible.sync="dialogVisible"
		width="600px"
		:before-close="handleClose"
		:close-on-click-modal="false"
		:append-to-body="true"
	>
		<div :class="['mb-12 p-16 radius-8 yx-background pos-rela', toggle ? '' : 'cursor-pointer']" @click="switchInput(true)">
			<div class="flex-row-align-center flex-just-between">
				<p class="font-h4-regular">
					<span>
						<i class="i-voice-recognition-line mb-2"></i>
						智能填写
					</span>
					<span class="yx-color-primary cursor-pointer ml-12" @click="identify">立即识别</span>
				</p>
				<div
					style="width: 80px; height: 52px; top: 0px; right: 0px"
					class="flex-row-align-center flex-just-end pos-abso cursor-pointer"
					@click.stop="switchInput(false)"
				>
					<i :class="['el-icon-arrow-down mr-16 arrow-down', toggle ? 'rotate' : '']"></i>
				</div>
			</div>
			<div v-if="toggle" class="mt-10">
				<el-input
					type="textarea"
					:rows="4"
					placeholder="粘贴信息，自动拆分姓名、电话和地址示例：大司马，136********，浙江省杭州市萧山区xx路xx号1栋B座506"
					show-word-limit
					v-model="address"
					maxlength="100"
				></el-input>
				<p class="font-h4-regular yx-color-text-secondary mt-8">识别后，请检查拆分地址信息是否准确，如有遗漏请及时补充</p>
			</div>
		</div>
		<el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
			<el-form-item label="收件人" prop="delivery_name">
				<el-input type="text" placeholder="请输入收件人" v-model="form.delivery_name" maxlength="10" show-word-limit />
			</el-form-item>
			<el-form-item label="手机号" prop="delivery_mobile">
				<el-input type="text" placeholder="请输入手机号" v-model="form.delivery_mobile" maxlength="11" />
			</el-form-item>
			<el-form-item label="所在区域" prop="province">
				<el-cascader class="width100" v-if="dialogVisible" @change="selecteFun" :options="AreaTree" clearable v-model="selectedOptions"></el-cascader>
			</el-form-item>
			<el-form-item label="详细地址" prop="delivery_addr">
				<el-input type="textarea" :rows="3" placeholder="请输入详细地址" v-model="form.delivery_addr" maxlength="60" show-word-limit />
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import throttle from 'lodash/throttle';
import area from '@/utils/area/index';
import { updDeliveryInfo } from '@/api/talentCRM';
// import { editAddressV1 } from '@/api/cooperationProgress';
import { getAddress } from '@/api/common';
export default {
	name: 'updateSampleDialog',
	watch: {
		toggle(to) {
			//智能识别输入框关闭，地址栏清空
			if (!to) {
				this.address = '';
			}
		},
	},
	data() {
		return {
			dialogVisible: false,
			selectedOptions: [],
			AreaTree: area.AreaTree,
			CodeToText: area.CodeToText,
			TextToCode: area.TextToCode,
			form: {
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
			},
			rules: {
				delivery_name: { required: true, message: '请输入收件人', trigger: 'blur' },
				delivery_mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
				province: { required: true, message: '请选择所在区域', trigger: 'change' },
				delivery_addr: { required: true, message: '请输入详细地址', trigger: 'blur' },
			},
			address: '',
			contact_id: '',
			toggle: false,
		};
	},
	methods: {
		show(delivery_info, contact_id) {
			Object.keys(this.form).forEach(key => (this.form[key] = delivery_info[key]));
			let [p, c] = this.TextToCode([delivery_info.province, delivery_info.city, delivery_info.area]);
			this.selectedOptions = [p, c, delivery_info.code];
			this.form.code = this.selectedOptions[2];
			this.contact_id = contact_id;
			this.dialogVisible = true;
		},
		handleClose() {
			this.form = {
				delivery_name: '',
				delivery_mobile: '',
				province: '',
				city: '',
				area: '',
				code: '',
				delivery_addr: '',
			};
			this.contact_id = '';
			this.address = '';
			this.toggle = false;
			this.selectedOptions = [];
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		selecteFun(e) {
			const code = e[2];
			const [province, city, area] = this.CodeToText(this.selectedOptions);
			this.form.province = province;
			this.form.city = city;
			this.form.area = area;
			this.form.code = code;
		},
		async identify() {
			const { address } = this;
			if (!address) return;
			const { code, data } = await getAddress({ address });
			if (code !== 0) return;
			Object.keys(this.form).forEach(key => (this.form[key] = data[key]));
			let [p, c] = this.TextToCode([data.province, data.city, data.area]);
			this.selectedOptions = [p, c, data.code];
			this.form.code = this.selectedOptions[2];
			this.toggle = false;
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { code } = await updDeliveryInfo({ ...this.form, contact_id: this.contact_id });
				if (code !== 0) return;
				this.$message.success('修改收货地址成功');
				this.$emit('getList');
				this.handleClose();
			});
		}, 1000),
		switchInput(value) {
			if (value) {
				this.toggle = value;
			} else {
				this.toggle = !this.toggle;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.arrow-down {
	transition: transform 0.3s;
	transform: rotate(0deg);
}
.rotate {
	transform: rotate(180deg);
}
</style>
